(function () {
  function toMoneySummaryItem(title, qty) {
    return qty + "x " + title;
  }

  function parseBool(value) {
    return value === "true" || value === true;
  }

  function initBuilder(root) {
    if (root.dataset.apexInit === "true") {
      return;
    }
    root.dataset.apexInit = "true";

    var caseSize = Number(root.getAttribute("data-case-size") || "0");
    var parentVariantId = Number(root.getAttribute("data-parent-variant-id") || "0");
    var parentHandle = root.getAttribute("data-parent-handle") || "";
    var caseSizeLabel = root.getAttribute("data-case-size-label") || (caseSize + " bottle");
    var startInBuilder = parseBool(root.getAttribute("data-start-builder"));

    if (!caseSize || !parentVariantId) {
      return;
    }

    var stepSelector = root.querySelector("[data-apex-step-selector]");
    var stepBuilder = root.querySelector("[data-apex-step-builder]");
    var progressEl = root.querySelector("[data-apex-progress]");
    var remainingEl = root.querySelector("[data-apex-remaining]");
    var addBtn = root.querySelector("[data-apex-add-btn]");
    var addBtnSurface = root.querySelector("[data-apex-add-btn-surface]");
    var errorEl = root.querySelector("[data-apex-error]");
    var selectionWrap = root.querySelector("[data-apex-selection]");
    var selectionList = root.querySelector("[data-apex-selection-list]");
    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-apex-beer-card]"));
    var state = {
      total: 0,
      lines: new Map(),
      loading: false
    };

    if (!cards.length) {
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.setAttribute("aria-disabled", "true");
      }
      return;
    }

    function showError(message) {
      if (!errorEl) return;
      if (!message) {
        errorEl.hidden = true;
        errorEl.textContent = "";
        return;
      }
      errorEl.hidden = false;
      errorEl.textContent = message;
    }

    function setBuilderVisible(visible) {
      if (!stepSelector || !stepBuilder) return;
      stepSelector.hidden = visible;
      stepBuilder.hidden = !visible;
    }

    function updateProgress() {
      var remaining = Math.max(0, caseSize - state.total);

      if (progressEl) {
        if (state.total === caseSize) {
          progressEl.textContent = "Perfect: your " + caseSizeLabel + " is complete";
        } else {
          progressEl.textContent = state.total + " of " + caseSize + " bottles selected";
        }
      }

      if (remainingEl) {
        if (remaining === 0) {
          remainingEl.textContent = "Ready to add to basket";
        } else if (remaining === 1) {
          remainingEl.textContent = "1 left to pick";
        } else {
          remainingEl.textContent = remaining + " left to pick";
        }
      }

      if (!addBtn) return;
      var canSubmit = state.total === caseSize && state.total > 0 && !state.loading;
      addBtn.disabled = !canSubmit;
      addBtn.classList.toggle("disabled", !canSubmit);
      addBtn.setAttribute("aria-disabled", canSubmit ? "false" : "true");

      if (addBtnSurface) {
        addBtnSurface.textContent = state.loading ? "Adding..." : "Add to basket";
      }
    }

    function updateSelectionSummary() {
      if (!selectionWrap || !selectionList) {
        return;
      }

      selectionList.innerHTML = "";

      if (!state.lines.size) {
        selectionWrap.hidden = true;
        return;
      }

      state.lines.forEach(function (line) {
        var li = document.createElement("li");
        li.className = "apex-build-a-box__selection-item";
        li.textContent = toMoneySummaryItem(line.title, line.quantity);
        selectionList.appendChild(li);
      });

      selectionWrap.hidden = false;
    }

    function updateCardStates() {
      cards.forEach(function (card) {
        var qtyValue = card.querySelector("[data-apex-qty-value]");
        var incBtn = card.querySelector('[data-action="increment"]');
        var decBtn = card.querySelector('[data-action="decrement"]');
        var qty = Number(qtyValue ? qtyValue.textContent : "0");
        var maxQty = Number(card.getAttribute("data-max-qty") || String(caseSize));
        var canIncrement = !state.loading && state.total < caseSize && qty < maxQty;
        var canDecrement = !state.loading && qty > 0;

        card.classList.toggle("is-selected", qty > 0);

        if (incBtn) {
          incBtn.disabled = !canIncrement;
          incBtn.setAttribute("aria-disabled", canIncrement ? "false" : "true");
        }

        if (decBtn) {
          decBtn.disabled = !canDecrement;
          decBtn.setAttribute("aria-disabled", canDecrement ? "false" : "true");
        }
      });
    }

    function recalcTotals() {
      var total = 0;
      cards.forEach(function (card) {
        var qtyValue = card.querySelector("[data-apex-qty-value]");
        var qty = Number(qtyValue ? qtyValue.textContent : "0");
        var variantId = Number(card.getAttribute("data-variant-id") || "0");
        var title = card.getAttribute("data-product-title") || "";

        total += qty;
        if (qty > 0 && variantId) {
          state.lines.set(String(variantId), {
            id: variantId,
            quantity: qty,
            title: title
          });
        } else {
          state.lines.delete(String(variantId));
        }
      });

      state.total = total;
      updateProgress();
      updateSelectionSummary();
      updateCardStates();
    }

    function adjust(card, direction) {
      if (state.loading) return;

      var qtyValue = card.querySelector("[data-apex-qty-value]");
      if (!qtyValue) return;

      var current = Number(qtyValue.textContent || "0");
      var next = current;
      var maxQty = Number(card.getAttribute("data-max-qty") || String(caseSize));

      if (direction === "increment") {
        if (state.total >= caseSize || current >= maxQty) return;
        next = current + 1;
      }

      if (direction === "decrement") {
        next = Math.max(0, current - 1);
      }

      if (next === current) return;

      qtyValue.textContent = String(next);
      recalcTotals();
    }

    function buildPayload() {
      var groupId = "apex-bundle-" + Date.now() + "-" + Math.floor(Math.random() * 10000);
      var summary = [];
      var items = [];

      items.push({
        id: parentVariantId,
        quantity: 1,
        properties: {
          _apex_bundle_parent: "true",
          _apex_bundle_type: "build_a_box",
          _apex_bundle_group_id: groupId,
          _apex_bundle_size: String(caseSize),
          _apex_bundle_parent_handle: parentHandle
        }
      });

      state.lines.forEach(function (line) {
        summary.push(toMoneySummaryItem(line.title, line.quantity));
        items.push({
          id: line.id,
          quantity: line.quantity,
          properties: {
            _apex_bundle_component: "true",
            _apex_bundle_type: "build_a_box",
            _apex_bundle_group_id: groupId,
            _apex_bundle_size: String(caseSize)
          }
        });
      });

      items[0].properties._apex_bundle_summary = summary.join("|");

      return {
        items: items,
        sections: "cart-items,cart-footer,cart-item-count,cart-live-region",
        sections_url: window.location.pathname
      };
    }

    async function submitBundle() {
      if (state.loading) return;
      if (state.total !== caseSize || state.lines.size === 0) {
        showError("Please select exactly " + caseSize + " bottles.");
        return;
      }

      showError("");
      state.loading = true;
      updateProgress();
      updateCardStates();

      try {
        var response = await fetch(theme.routes.cart_add_url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/javascript",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify(buildPayload())
        });

        var data = await response.json();
        if (data.status) {
          showError(data.description || "Unable to add bundle to cart.");
        } else {
          cards.forEach(function (card) {
            var qtyValue = card.querySelector("[data-apex-qty-value]");
            if (qtyValue) {
              qtyValue.textContent = "0";
            }
          });
          recalcTotals();

          document.body.dispatchEvent(new CustomEvent("shapes:cart:afteradditem", {
            bubbles: true,
            detail: {
              response: data,
              sourceId: "apex-build-a-box"
            }
          }));
        }
      } catch (error) {
        showError("Unable to add bundle to cart. Please try again.");
        console.error(error);
      } finally {
        state.loading = false;
        updateProgress();
        updateCardStates();
      }
    }

    root.addEventListener("click", function (event) {
      var prevBtn = event.target.closest("[data-apex-btn-prev]");
      if (prevBtn) {
        event.preventDefault();
        setBuilderVisible(false);
        return;
      }

      var caseLink = event.target.closest("[data-apex-case-link]");
      if (caseLink) {
        var isCurrent = parseBool(caseLink.getAttribute("data-is-current"));
        if (isCurrent) {
          event.preventDefault();
          setBuilderVisible(true);
          return;
        }
        return;
      }

      var qtyButton = event.target.closest("[data-action]");
      if (qtyButton) {
        var card = qtyButton.closest("[data-apex-beer-card]");
        if (!card) return;
        adjust(card, qtyButton.getAttribute("data-action"));
        return;
      }

      if (addBtn && event.target.closest("[data-apex-add-btn]")) {
        event.preventDefault();
        submitBundle();
      }
    });

    recalcTotals();
    setBuilderVisible(startInBuilder);
  }

  async function removeBundle(groupId) {
    var cartRes = await fetch(theme.routes.cart_url + ".js", {
      headers: {
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    });
    var cart = await cartRes.json();
    var updates = {};

    cart.items.forEach(function (item) {
      if (
        item.properties &&
        item.properties._apex_bundle_group_id &&
        item.properties._apex_bundle_group_id === groupId
      ) {
        updates[item.key] = 0;
      }
    });

    if (Object.keys(updates).length === 0) {
      return null;
    }

    var updateRes = await fetch(theme.routes.cart_update_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/javascript",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({
        updates: updates,
        sections: "cart-items,cart-footer,cart-item-count,cart-live-region",
        sections_url: window.location.pathname
      })
    });

    return updateRes.json();
  }

  async function cleanupOrphanBundleComponents() {
    var cartRes = await fetch(theme.routes.cart_url + ".js", {
      headers: {
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    });
    var cart = await cartRes.json();
    var updates = {};
    var parentGroups = {};

    cart.items.forEach(function (item) {
      if (
        item.properties &&
        item.properties._apex_bundle_parent === "true" &&
        item.properties._apex_bundle_group_id
      ) {
        parentGroups[item.properties._apex_bundle_group_id] = true;
      }
    });

    cart.items.forEach(function (item) {
      if (
        item.properties &&
        item.properties._apex_bundle_component === "true" &&
        item.properties._apex_bundle_group_id &&
        !parentGroups[item.properties._apex_bundle_group_id]
      ) {
        updates[item.key] = 0;
      }
    });

    if (Object.keys(updates).length === 0) {
      return null;
    }

    var updateRes = await fetch(theme.routes.cart_update_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/javascript",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({
        updates: updates,
        sections: "cart-items,cart-footer,cart-item-count,cart-live-region",
        sections_url: window.location.pathname
      })
    });

    return updateRes.json();
  }

  function dispatchCartSectionsUpdate(response) {
    if (response && response.sections) {
      document.body.dispatchEvent(new CustomEvent("shapes:cart:update", {
        bubbles: true,
        detail: { response: response }
      }));
    }
  }

  function initBundleRemove() {
    if (window.__apexBundleRemoveInit) return;
    window.__apexBundleRemoveInit = true;

    document.addEventListener("click", async function (event) {
      var trigger = event.target.closest("[data-apex-remove-bundle]");
      if (!trigger) return;

      event.preventDefault();
      var groupId = trigger.getAttribute("data-apex-remove-bundle");
      if (!groupId) return;

      trigger.setAttribute("aria-busy", "true");
      try {
        var response = await removeBundle(groupId);
        dispatchCartSectionsUpdate(response);
      } catch (error) {
        console.error(error);
      } finally {
        trigger.removeAttribute("aria-busy");
      }
    });
  }

  function boot() {
    document.querySelectorAll("[data-apex-build-a-box]").forEach(initBuilder);
    initBundleRemove();

    cleanupOrphanBundleComponents()
      .then(function (response) {
        dispatchCartSectionsUpdate(response);
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
